import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Ikon fix a React 18 + react-leaflet 4.x-hez
const DefaultIcon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const SimpleMap = () => {
  const locations = [
    {
      lat: 47.8353587,
      lng: 19.6724872,
      name: "Házhoz",
      info: "3063 Jobbágyi, Fáy András utca 12",
    },
    {
      lat: 47.6049621,
      lng: 19.0498972,
      name: "Delice Éden Szépségszalon",
      info: "1038 Budapest, Éden utca 8.",
    },
  ];

  return (
    <div
      style={{
        height: "350px",
        width: "100%",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <MapContainer
        center={[47.69875427842055, 19.463024288269803]}
        zoom={9}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {locations.map((location, index) => (
          <Marker
            key={index}
            position={[location.lat, location.lng]}
            icon={DefaultIcon}
          >
            <Popup className="custom-popup">
              <div style={{ padding: "8px" }}>
                <h4 style={{ margin: "0 0 8px 0" }}>{location.name}</h4>
                <p style={{ margin: 0 }}>{location.info}</p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default SimpleMap;
